import './styles.scss'

export type CloseButtonProps = {
  backgroundColor?: string
  className?: string
  onClick: () => void
}

const CLASS_NAME = 'close-button'

export const CloseButton = ({ backgroundColor, className, onClick }: CloseButtonProps) => {
  return (
    <button
      className={`${CLASS_NAME} ${className}`}
      tabIndex={0}
      onClick={onClick}
      style={{ backgroundColor: backgroundColor ? backgroundColor : 'var(--standard-light-color' }}>
      <img aria-label="Close" src="/icons/close.png" />
    </button>
  )
}
